// source: cat_graph.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var plan_reviewer_pb = require('./plan.reviewer_pb.js');
goog.object.extend(proto, plan_reviewer_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraph', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.Relation', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.Kind', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Inference', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Op', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Kind', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Status', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.Verdict', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraph, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraph';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.displayName = 'proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.repeatedFields_ = [6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.toObject = function(includeInstance, msg) {
  var f, obj = {
schema: jspb.Message.getFieldWithDefault(msg, 1, ""),
graphId: jspb.Message.getFieldWithDefault(msg, 2, ""),
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 3, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 5, ""),
revisionsList: jspb.Message.toObjectList(msg.getRevisionsList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.toObject, includeInstance),
termsList: jspb.Message.toObjectList(msg.getTermsList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.toObject, includeInstance),
argumentsList: jspb.Message.toObjectList(msg.getArgumentsList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.toObject, includeInstance),
citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    plan_reviewer_pb.EvidenceCitation.toObject, includeInstance),
generatedBy: jspb.Message.getFieldWithDefault(msg, 10, ""),
createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraph;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchema(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.deserializeBinaryFromReader);
      msg.addRevisions(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.deserializeBinaryFromReader);
      msg.addTerms(value);
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.deserializeBinaryFromReader);
      msg.addArguments(value);
      break;
    case 9:
      var value = new plan_reviewer_pb.EvidenceCitation;
      reader.readMessage(value,plan_reviewer_pb.EvidenceCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneratedBy(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchema();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRevisionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.serializeBinaryToWriter
    );
  }
  f = message.getTermsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.serializeBinaryToWriter
    );
  }
  f = message.getArgumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.serializeBinaryToWriter
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      plan_reviewer_pb.EvidenceCitation.serializeBinaryToWriter
    );
  }
  f = message.getGeneratedBy();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string schema = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getSchema = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setSchema = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string graph_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string architectural_plan_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subtitle = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated CatGraphRevision revisions = 6;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getRevisionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision, 6));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setRevisionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.addRevisions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.clearRevisionsList = function() {
  return this.setRevisionsList([]);
};


/**
 * repeated CatGraphTerm terms = 7;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getTermsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm, 7));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setTermsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.addTerms = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.clearTermsList = function() {
  return this.setTermsList([]);
};


/**
 * repeated CatGraphArgument arguments = 8;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getArgumentsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument, 8));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setArgumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.addArguments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.clearArgumentsList = function() {
  return this.setArgumentsList([]);
};


/**
 * repeated org.codetricks.construction.code.assistant.EvidenceCitation citations = 9;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.EvidenceCitation>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.EvidenceCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, plan_reviewer_pb.EvidenceCitation, 9));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.EvidenceCitation>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.EvidenceCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.EvidenceCitation}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.org.codetricks.construction.code.assistant.EvidenceCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};


/**
 * optional string generated_by = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getGeneratedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setGeneratedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp created_time = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraph} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraph.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.toObject = function(includeInstance, msg) {
  var f, obj = {
revisionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
date: jspb.Message.getFieldWithDefault(msg, 3, ""),
note: jspb.Message.getFieldWithDefault(msg, 4, ""),
datasetIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
unavailable: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRevisionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addDatasetIds(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnavailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRevisionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDatasetIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getUnavailable();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string revision_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.getRevisionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.setRevisionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string date = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string note = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string dataset_ids = 5;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.getDatasetIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.setDatasetIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.addDatasetIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.clearDatasetIdsList = function() {
  return this.setDatasetIdsList([]);
};


/**
 * optional string unavailable = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.getUnavailable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevision.prototype.setUnavailable = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
term: jspb.Message.getFieldWithDefault(msg, 1, ""),
meaning: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerm(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMeaning(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTerm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeaning();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string term = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.prototype.getTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.prototype.setTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string meaning = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.prototype.getMeaning = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphTerm.prototype.setMeaning = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.toObject = function(includeInstance, msg) {
  var f, obj = {
argumentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
heading: jspb.Message.getFieldWithDefault(msg, 2, ""),
caption: jspb.Message.getFieldWithDefault(msg, 3, ""),
relation: jspb.Message.getFieldWithDefault(msg, 4, 0),
loose: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
nodesList: jspb.Message.toObjectList(msg.getNodesList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.toObject, includeInstance),
gatesList: jspb.Message.toObjectList(msg.getGatesList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArgumentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeading(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.Relation} */ (reader.readEnum());
      msg.setRelation(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLoose(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.deserializeBinaryFromReader);
      msg.addNodes(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.deserializeBinaryFromReader);
      msg.addGates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArgumentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeading();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRelation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLoose();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getNodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.serializeBinaryToWriter
    );
  }
  f = message.getGatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.Relation = {
  RELATION_UNSPECIFIED: 0,
  CONFIRMS: 1,
  NARROWS: 2,
  CONTRADICTS: 3,
  CANNOT_DETERMINE: 4
};

/**
 * optional string argument_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getArgumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setArgumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string heading = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getHeading = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setHeading = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string caption = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Relation relation = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.Relation}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getRelation = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.Relation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.Relation} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setRelation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool loose = 5;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getLoose = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setLoose = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated CatGraphNode nodes = 6;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getNodesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode, 6));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setNodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.addNodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.clearNodesList = function() {
  return this.setNodesList([]);
};


/**
 * repeated CatGraphGate gates = 7;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.getGatesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate, 7));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.setGatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.addGates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphArgument.prototype.clearGatesList = function() {
  return this.setGatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.toObject = function(includeInstance, msg) {
  var f, obj = {
nodeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
statement: jspb.Message.getFieldWithDefault(msg, 3, ""),
summary: jspb.Message.getFieldWithDefault(msg, 4, ""),
role: jspb.Message.getFieldWithDefault(msg, 5, ""),
source: jspb.Message.getFieldWithDefault(msg, 6, ""),
revisionId: jspb.Message.getFieldWithDefault(msg, 7, ""),
status: jspb.Message.getFieldWithDefault(msg, 8, 0),
statusText: jspb.Message.getFieldWithDefault(msg, 9, ""),
note: jspb.Message.getFieldWithDefault(msg, 10, ""),
evidenceList: jspb.Message.toObjectList(msg.getEvidenceList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.toObject, includeInstance),
resolves: (f = msg.getResolves()) && proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.toObject(includeInstance, f),
proposed: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodeId(value);
      break;
    case 2:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRevisionId(value);
      break;
    case 8:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusText(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 11:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.deserializeBinaryFromReader);
      msg.addEvidence(value);
      break;
    case 12:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.deserializeBinaryFromReader);
      msg.setResolves(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProposed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRevisionId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getStatusText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.serializeBinaryToWriter
    );
  }
  f = message.getResolves();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.serializeBinaryToWriter
    );
  }
  f = message.getProposed();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Kind = {
  KIND_UNSPECIFIED: 0,
  PLAN: 1,
  DOCUMENT: 2,
  CODE: 3,
  ABSENCE: 4,
  ASSUMPTION: 5,
  OBJECTIVE: 6,
  INTERMEDIATE: 7,
  CONCLUSION: 8,
  CLAIM: 9,
  UNSTATED: 10
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Status = {
  STATUS_UNSPECIFIED: 0,
  VERIFIED_TRUE: 1,
  VERIFIED_FALSE: 2,
  UNVERIFIED: 3,
  NOT_ESTABLISHED: 4
};

/**
 * optional string node_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Kind kind = 2;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Kind}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getKind = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Kind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Kind} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string statement = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string summary = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string role = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string source = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string revision_id = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getRevisionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setRevisionId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Status status = 8;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Status}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Status} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.Status} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string status_text = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getStatusText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setStatusText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string note = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated CatGraphEvidence evidence = 11;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getEvidenceList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence, 11));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.addEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.clearEvidenceList = function() {
  return this.setEvidenceList([]);
};


/**
 * optional CatGraphRevisionCheck resolves = 12;
 * @return {?proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getResolves = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck, 12));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setResolves = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.clearResolves = function() {
  return this.setResolves(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.hasResolves = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool proposed = 13;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.getProposed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphNode.prototype.setProposed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.toObject = function(includeInstance, msg) {
  var f, obj = {
kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
revisionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
citationIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
external: (f = msg.getExternal()) && proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.toObject(includeInstance, f),
searchScope: (f = msg.getSearchScope()) && proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRevisionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addCitationIds(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.deserializeBinaryFromReader);
      msg.setExternal(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.deserializeBinaryFromReader);
      msg.setSearchScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRevisionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCitationIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getExternal();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.serializeBinaryToWriter
    );
  }
  f = message.getSearchScope();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.Kind = {
  KIND_UNSPECIFIED: 0,
  PLAN: 1,
  CODE: 2,
  DOCUMENT: 3,
  SCOPE: 4
};

/**
 * optional Kind kind = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.Kind}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getKind = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.Kind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.Kind} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string revision_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getRevisionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setRevisionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string citation_ids = 5;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getCitationIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setCitationIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.addCitationIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.clearCitationIdsList = function() {
  return this.setCitationIdsList([]);
};


/**
 * optional ExternalDocumentReference external = 6;
 * @return {?proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getExternal = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference, 6));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setExternal = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.clearExternal = function() {
  return this.setExternal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.hasExternal = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CatGraphSearchScope search_scope = 7;
 * @return {?proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.getSearchScope = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope, 7));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.setSearchScope = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.clearSearchScope = function() {
  return this.setSearchScope(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphEvidence.prototype.hasSearchScope = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
locator: jspb.Message.getFieldWithDefault(msg, 2, ""),
uri: jspb.Message.getFieldWithDefault(msg, 3, ""),
accessLimitation: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference;
  return proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocator(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessLimitation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccessLimitation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string locator = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.getLocator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.setLocator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string uri = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.getUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.setUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string access_limitation = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.getAccessLimitation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.ExternalDocumentReference.prototype.setAccessLimitation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.toObject = function(includeInstance, msg) {
  var f, obj = {
description: jspb.Message.getFieldWithDefault(msg, 1, ""),
sheetIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
expectedTermsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addSheetIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addExpectedTerms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSheetIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getExpectedTermsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string sheet_ids = 2;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.getSheetIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.setSheetIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.addSheetIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.clearSheetIdsList = function() {
  return this.setSheetIdsList([]);
};


/**
 * repeated string expected_terms = 3;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.getExpectedTermsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.setExpectedTermsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.addExpectedTerms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSearchScope.prototype.clearExpectedTermsList = function() {
  return this.setExpectedTermsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.repeatedFields_ = [2,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.toObject = function(includeInstance, msg) {
  var f, obj = {
op: jspb.Message.getFieldWithDefault(msg, 1, 0),
inputsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
output: jspb.Message.getFieldWithDefault(msg, 3, ""),
inference: jspb.Message.getFieldWithDefault(msg, 4, 0),
alternativesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
proposed: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Op} */ (reader.readEnum());
      msg.setOp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addInputs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutput(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Inference} */ (reader.readEnum());
      msg.setInference(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addAlternatives(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProposed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOp();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getInputsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getOutput();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInference();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAlternativesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getProposed();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Op = {
  OP_UNSPECIFIED: 0,
  AND: 1,
  OR: 2
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Inference = {
  INFERENCE_UNSPECIFIED: 0,
  DEDUCTION: 1,
  GENERALIZATION: 2,
  BEST_EXPLANATION: 3,
  ANALOGY: 4
};

/**
 * optional Op op = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Op}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.getOp = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Op} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Op} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.setOp = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string inputs = 2;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.getInputsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.setInputsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.addInputs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.clearInputsList = function() {
  return this.setInputsList([]);
};


/**
 * optional string output = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.getOutput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.setOutput = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Inference inference = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Inference}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.getInference = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Inference} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.Inference} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.setInference = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated string alternatives = 5;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.getAlternativesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.setAlternativesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.addAlternatives = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.clearAlternativesList = function() {
  return this.setAlternativesList([]);
};


/**
 * optional bool proposed = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.getProposed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphGate.prototype.setProposed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.toObject = function(includeInstance, msg) {
  var f, obj = {
foundOn: jspb.Message.getFieldWithDefault(msg, 1, ""),
checkedOn: jspb.Message.getFieldWithDefault(msg, 2, ""),
verdict: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFoundOn(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckedOn(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.Verdict} */ (reader.readEnum());
      msg.setVerdict(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFoundOn();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCheckedOn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVerdict();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.Verdict = {
  VERDICT_UNSPECIFIED: 0,
  RESOLVED: 1,
  PARTLY_RESOLVED: 2,
  NOT_RESOLVED: 3,
  CANNOT_DETERMINE: 4
};

/**
 * optional string found_on = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.getFoundOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.setFoundOn = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string checked_on = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.getCheckedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.setCheckedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Verdict verdict = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.Verdict}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.getVerdict = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.Verdict} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.Verdict} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphRevisionCheck.prototype.setVerdict = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
graphId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest}
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest;
  return proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest}
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string graph_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.GetCatGraphRequest.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.toObject = function(includeInstance, msg) {
  var f, obj = {
svg: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSvg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSvg();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string svg = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.prototype.getSvg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphPicture.prototype.setSvg = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest;
  return proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
graphId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
argumentCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
nodeCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
gateCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
generatedBy: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary;
  return proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArgumentCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNodeCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGateCount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneratedBy(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getArgumentCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNodeCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getGateCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getGeneratedBy();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string graph_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subtitle = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 argument_count = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getArgumentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setArgumentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 node_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getNodeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setNodeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 gate_count = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getGateCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setGateCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string generated_by = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getGeneratedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setGeneratedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
graphsList: jspb.Message.toObjectList(msg.getGraphsList(),
    proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse;
  return proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.deserializeBinaryFromReader);
      msg.addGraphs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGraphsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CatGraphSummary graphs = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary>}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.prototype.getGraphsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary>} value
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.prototype.setGraphsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary}
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.prototype.addGraphs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.catgraph.CatGraphSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.catgraph.ListCatGraphsResponse.prototype.clearGraphsList = function() {
  return this.setGraphsList([]);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.catgraph);
